import { useCallback, useEffect, useState } from "react";

import { getMenuSettings } from "services/menu/rest";
import { MenuSettingsDto } from "services/menu/restModels";

export interface UseMenuSettingsResult {
    settings: MenuSettingsDto | null;
    loading: boolean;
    error: boolean;
    refetch: () => void;
}

export const useMenuSettings = (menuId: number): UseMenuSettingsResult => {
    const [settings, setSettings] = useState<MenuSettingsDto | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<boolean>(false);
    const [reloadKey, setReloadKey] = useState<number>(0);

    const refetch = useCallback(() => setReloadKey((key) => key + 1), []);

    useEffect(() => {
        // ignore-флаг: поздний ответ по старому menuId не перезапишет свежий.
        let ignore = false;

        setLoading(true);
        setError(false);

        getMenuSettings(menuId)
            .then((result) => {
                if (ignore) return;
                if (result) {
                    setSettings(result);
                } else {
                    setError(true);
                    setSettings(null);
                }
            })
            .catch(() => {
                if (ignore) return;
                setError(true);
                setSettings(null);
            })
            .finally(() => {
                if (ignore) return;
                setLoading(false);
            });

        return () => {
            ignore = true;
        };
    }, [menuId, reloadKey]);

    return { settings, loading, error, refetch };
};
